import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom';
import Homepage from './components/Homepage';
import Application from './components/Request/Application';
import React from "react";
import CustomerCollection from './components/CustomerCollection/CustomerCollection';
import CustomerReturn from "./components/Return/CustomerReturn";
import Measurement from './components/Measurement/Measurement';
import config from './config';

function Router(props: any) {

  const apiprefix = config.APP_APIPREFIX ?? '';
  const company = config.APP_COMPANY ?? '';
  const hasPermission = props.hasPermission ?? true;

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/Login" element={<p>login</p>} />
        <Route path="/" element={<Homepage company={company} accessToken={props.accessToken} hasPermission={hasPermission} />} />
        <Route path="/home" element={<Homepage company={company} accessToken={props.accessToken} hasPermission={hasPermission}/>} />
        <Route path="/home/login" element={<p>Request 申請的登录页面</p>} />
        <Route path="/home/application" element={<Application apiprefix={apiprefix} company={company} account={props.account} userData={props.userData} accessToken={props.accessToken} hasPermission={hasPermission}/>} />
        <Route path="/home/customercollection" element={<CustomerCollection apiprefix={apiprefix} accessToken={props.accessToken} hasPermission={hasPermission}/>} />
        <Route path="/home/measurement" element={<Measurement apiprefix={apiprefix} accessToken={props.accessToken} hasPermission={hasPermission}/>} />
        <Route path="/home/customerreturn" element={<CustomerReturn apiprefix={apiprefix} accessToken={props.accessToken} hasPermission={hasPermission}/>} />
      </>
    ),
    {
      basename: process.env.PUBLIC_URL
    }
  );

  return <RouterProvider router={router} />;
}

export default React.memo(Router);